import React from "react";
import "./style.css";
import Typewriter from "typewriter-effect";
import { introdata } from "../../content_option";


export const Home = (props) => {
  const onAboutUsClick = () => {
    props.onAboutUsClick && props.onAboutUsClick()
  }
  const onPortfolioClick = () => {
    props.onPortfolioClick && props.onPortfolioClick()
  }
  return (
    <section id="home" className="home">
      <div style={{ justifyContent: 'center' }} className="intro_sec d-block d-lg-flex align-items-center ">
        <div
          className="h_bg-image order-1 order-lg-2 h-100 invertable"
          style={{ maxWidth: '500px', backgroundImage: `url(${introdata.your_img_url})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain' }}
        ></div>
        <div className="text order-2 order-lg-1 h-100 d-lg-flex">
          <div className="align-self-center ">
            <div className="intro mx-auto">
              <h2 className="mb-1x">{introdata.title}</h2>
              <h1 className="fluidz-48 mb-1x">
                <Typewriter
                  options={{
                    strings: [
                      introdata.animated.first,
                      introdata.animated.second,
                      introdata.animated.third,
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 10,
                  }}
                />
              </h1>
              <p style={{whiteSpace: 'pre-line'}} className="mb-1x">{introdata.description}</p>
              <div className="intro_btn-action pb-5">
                <button onClick={onPortfolioClick} className="ac_btn btn btn-portfolio">

                  Portfolio

                </button>
                <button onClick={onAboutUsClick} className="ac_btn btn btn-abtus">

                  Über uns

                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
